import { getDataAPI, postDataAPI } from "../../../helper/api";

export const requestGetProviderCategories = () => {
  return getDataAPI("/api/provider/categories");
};

export const requestGetproviderSearchData = (payload) => {
  return postDataAPI("/api/provider/searchProvidersByAddressV2", {
    ...payload,
  });
};

export const requestGetProviderApiCallCountByClient = (payload) => {
  return getDataAPI(`/api/provider/ClientTracking/${payload}`);
};

export const requestGetproviderSearchDataByName = (payload) => {
  return postDataAPI("/api/provider/searchByNameV2", {
    ...payload,
    version: 0,
  });
};

export const requestGetProviderNamePrediction = (payload) => {
  return postDataAPI(`/api/Provider/ProviderNamePrediction`, { ...payload });
};

export const requestGetCptCodeSuggestion = (payload) => {
  return postDataAPI(`/api/Provider/getCptCode`, { ...payload });
};

export const requestGetProviderSearchDataByCptCode = (payload) => {
  return postDataAPI(`/api/Provider/SearchByCptCodeV2`, { ...payload });
};

export const requestGetProviderSearchDataByFacility = (payload) => {
  return postDataAPI(`/api/Provider/SearchFacilityByTypeAndAddress`, {
    ...payload,
  });
};

export const requestAddProviderComment = (payload) => {
  return postDataAPI(`/api/Client/Comment`, {
    ...payload,
  });
};

export const requestGetProviderComment = (payload) => {
  return getDataAPI(`/api/Client/Comment/${payload}`);
};

export const requestAddProviderLikeFeedback = (payload) => {
  return postDataAPI(`/api/Client/LikeFeedback`, {
    ...payload,
  });
};

export const requestUsersActivities = () => {
  return getDataAPI(`/api/Client/UsersActivity`, {});
};

export const requestUserActivities = () => {
  return getDataAPI(`/api/Client/UserActivity`, {});
};

export const requestNPIBackgroundActivities = (npi) => {
  return getDataAPI(
    `/api/Provider/BackgroundSearch/${npi?.npi}?refresh=${npi?.refresh}`,
    {}
  );
};

export const requestProviderSearchDataByNpi = (payload) => {
  return getDataAPI(`/api/provider/searchByNpiV2/${payload}`);
};

export const requestAddClaim = (payload) => {
  return postDataAPI(`/api/Client/Claim`, {
    ...payload,
  });
};
